import { createApp } from 'vue'
import Results from '@/wholesale/results';
import SearchForm from '@/wholesale/search-form';
import WholesaleStore from '@/wholesale/wholesale-store';
import VueInitialData from '../libs/vue-initial-data';

import { mapState } from 'vuex';

const wholesaleApp = createApp({
    components: {
        SearchForm,
        'search-results' : Results
    },
    computed: {
        ...mapState([
            'searchFilters'
        ]),
    },
    created() {
        this.$store.commit('userCountryCode', this.getInitialData('UserCountryCode'));
    }
});

wholesaleApp.use(VueInitialData);
wholesaleApp.use(WholesaleStore);
wholesaleApp.mount('#wholesale');